import { render, staticRenderFns } from "./verbaleGVR.vue?vue&type=template&id=aa7a6740"
import script from "./verbaleGVR.vue?vue&type=script&lang=js"
export * from "./verbaleGVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports